import axios from 'axios';

let envVersion = 'develop';//develop--开发版 || trial--测试版 || release--正式版
let HURL = '';
switch (envVersion) {
  case 'develop'://开发版
    HURL = "https://api.aso.gzjiuyi.net"
    break;
  case 'trial'://测试版
    HURL = "https://api.aso.gzjiuyi.net"
    break;
  case 'release'://正式版
    HURL = "https://api.aso.gzjiuyi.net"
    break;
}

// 登录请求方法
const loginRequest = (method, url, params) => {
    return axios({
        method: method,
        url: HURL + url,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        data: params,
        traditional: true,
    }).then(res => res.data);
};
// 通用公用方法
const commRequest = (method, url, params) => {
    var _this = this;
    if(method == 'get'){
        var data='';
        if(params){
            for (const key in params) {
                if(params[key]){
                    data+=key+'='+params[key]+'&'
                }
            }
            data=data.slice(0,data.length-1)
        }
        if(data){
            url = url+ '?' +data
        }
        return axios({
            method: method,
            url: HURL + url,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'token': localStorage.getItem('logintoken')
            },
            traditional: true,
        }).then(res => {
            if(res.data.statusCode == 200){
                // 成功
                return res.data
            }else if(res.data.statusCode == 600){
                // 登录状态失效
                _this.$store.commit('logout', 'false')
                _this.$router.push({ path: '/login' })
            }else{
                return res.data
            }
        });
    }else{
        return axios({
            method: method,
            url: HURL + url,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'token': localStorage.getItem('logintoken')
            },
            data: params,
            traditional: true,
        }).then(res => {
            if(res.data.statusCode == 200){
                // 成功
                return res.data
            }else if(res.data.statusCode == 600){
                // 登录状态失效
                _this.$store.commit('logout', 'false')
                _this.$router.push({ path: '/login' })
            }else{
                return res.data
            }
        });
    }
    
};

export {
    loginRequest,
    commRequest
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js